import { mountNotification } from '../../../components/notification.component';
import { CONTAINER_ERROR_NOTIFICATION } from '../constant';
import { IErrorObj } from '../interfaces/main.interface';
import { trackIt } from '@vfde-sails/tracking';
import { IButtonProperties } from '@vfde-brix/ws10/button';
import {
    ButtonLinkColorVariant,
    IButtonLinkProperties,
    OptIconPosition,
} from '@vfde-brix/ws10/button-link';
import { CLASSNAME_HIDDEN } from '@vfde-brix/ws10/styles';

/**
 * handle any error that our authentication application can produce
 */
export const handleError = (error: IErrorObj | null): void => {
    if (!error) {
        const container = document.getElementById(CONTAINER_ERROR_NOTIFICATION);

        while (container?.firstChild) {
            container.removeChild(container.firstChild);
        }

        return;
    }

    const { code, message, type, area } = error;

    // if the error is not a trackable one we just return since it's enough that we stored the error for debugging
    if (!type && !area) {
        return;
    }

    // Check for error in brixPageOptions or use default
    const errorEntry = window.brixPageOptions?.errors?.[code] || window.brixPageOptions?.errors?.default;
    const { stdHeadline, txtContent, button = {} } = errorEntry;
    const { stdLabel, linkHref } = button;
    const finalMessage = message || txtContent;

    trackIt('error', error);

    let containerButtons: (IButtonProperties | IButtonLinkProperties)[] | undefined;

    if (button && stdLabel && linkHref) {
        containerButtons = [{
            stdLabel,
            linkHref,
            type: 'ButtonLink',
            optTarget: '_self',
            optColorVariant: 'color-primary-200' as ButtonLinkColorVariant,
            optDisabled: false,
            stdSystemIconName: 'chevron-right',
            optIconPosition: OptIconPosition.RIGHT,
            business: {},
        }];
    }

    const errorElWrapper = document.getElementById(CONTAINER_ERROR_NOTIFICATION);

    if (errorElWrapper) {
        mountNotification(CONTAINER_ERROR_NOTIFICATION,
            {
                optState: 'error',
                stdHeadline,
                txtContent: finalMessage,
                containerButtons,
            });

        errorElWrapper.classList.remove(CLASSNAME_HIDDEN);
    }
};
